import styles from './AuthLayout.module.css';

import type { ReactNode } from 'react';

interface AuthLayoutProps {
  readonly title: string;
  readonly subtitle?: ReactNode;
  readonly children: ReactNode;
  readonly footer?: ReactNode;
}

/**
 * Moldura das telas de acesso.
 *
 * O <code>h1</code> é o título da tela, não a marca. Quem navega por cabeçalho
 * espera que o primeiro diga o que a página faz — "ObraLink" não informa se
 * isto é login ou cadastro (docs/22 §3).
 */
export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps): JSX.Element {
  return (
    <div className={styles.shell}>
      <main className={styles.card}>
        <p className={styles.brand}>ObraLink</p>

        <h1 className={styles.title}>{title}</h1>
        {subtitle !== undefined && <p className={styles.subtitle}>{subtitle}</p>}

        {children}

        {footer !== undefined && <div className={styles.footer}>{footer}</div>}
      </main>
    </div>
  );
}
